export default {"src":"/_next/static/media/team-grid.7987083e.svg","height":731,"width":1169,"blurWidth":0,"blurHeight":0};